import React from 'react';
import {Link} from "react-router-dom";
import {Col, Row} from "reactstrap";
import ilead_tools from "../../resources/icons/29.svg";
import http from "../../libs/http";
import Home from "./Pages/Home";
import SideBar from "./Pages/SideBar";
import People from "./Pages/People";
import Task from "./Pages/Task";
import Thought from "./Pages/Thought";
import HowToMotivateOthers from "./Pages/People/Mobilising/HowToMotivateOthers/HowToMotivateOthers";
import HowToRaiseEnergyLevels from "./Pages/People/Mobilising/HowToRaiseEnergyLevels/HowToRaiseEnergyLevels";
import HowToBeAssertive from "./Pages/People/Mobilising/HowToBeAssertive/HowToBeAssertive";
import HowToInfluenceOthers from "./Pages/People/Mobilising/HowToInfluenceOthers/HowToInfluenceOthers";
import HowToDevelopRapport from "./Pages/People/Connecting/HowToDevelopRapport/HowToDevelopRapport";
import HowToCommunicateEffectively from "./Pages/People/Connecting/HowToCommunicateEffectively/HowToCommunicateEffectively";
import HowToActivelyListen from "./Pages/People/Connecting/HowToActivelyListen/HowToActivelyListen";
import HowToManageYourImpact from "./Pages/People/Connecting/HowToManageYourImpact/HowToManageYourImpact";
import HowToManageDifficultConversations from "./Pages/People/Connecting/HowToManageDifficultConversations/HowToManageDifficultConversations";
import HowToGiveFeedback from "./Pages/People/Building/HowToGiveFeedback/HowToGiveFeedback";
import HowToSupportAndChallengeInTandem from "./Pages/People/Building/HowToSupportAndChallengeInTandem/HowToSupportAndChallengeInTandem";
import HowToBuildAndMaintainTrust from "./Pages/People/Building/HowToBuildAndMaintainTrust/HowToBuildAndMaintainTrust";
import HowToCreateTeamIdentity from "./Pages/People/Building/HowToCreateTeamIdentity/HowToCreateTeamIdentity";
import HowToGainBuyInAndCommitment from "./Pages/People/Building/HowToGainBuyInAndCommitment/HowToGainBuyInAndCommitment";
import HowToDevelopOthers from "./Pages/People/Meaning/HowToDevelopOthers/HowToDevelopOthers";
import HowToIdentifyPersonalLearningStyles from "./Pages/People/Meaning/HowToIdentifyPersonalLearningStyles/HowToIdentifyPersonalLearningStyles";
import HowToBeAnEffectiveRoleModel from "./Pages/People/Meaning/HowToBeAnEffectiveRoleModel/HowToBeAnEffectiveRoleModel";
import HowToIdentifyYourPersonalMeaning from "./Pages/People/Meaning/HowToIdentifyYourPersonalMeaning/HowToIdentifyYourPersonalMeaning";
import HowToBalanceRiskWithPotentialBenefits from "./Pages/Thought/Challenging/HowToBalanceRiskWithPotentialBenefits/HowToBalanceRiskWithPotentialBenefits";
import HowToChallengeOthersEffectively from "./Pages/Thought/Challenging/HowToChallengeOthersEffectively/HowToChallengeOthersEffectively";
import HowToFocusOnTheBiggerPicture from "./Pages/Thought/Discerning/HowToFocusOnTheBiggerPicture/HowToFocusOnTheBiggerPicture";
import HowToMakeComplexIdeasSimpleClearAndConcise from "./Pages/Thought/Discerning/HowToMakeComplexIdeasSimpleClearAndConcise/HowToMakeComplexIdeasSimpleClearAndConcise";
import HowToMakeEthicalDecisions from "./Pages/Thought/Discerning/HowToMakeEthicalDecisions/HowToMakeEthicalDecisions";
import HowToMakeTimelyDecisions from "./Pages/Thought/Discerning/HowToMakeTimelyDecisions/HowToMakeTimelyDecisions";
import HowToPrioritiseTasksReadyForAction from "./Pages/Thought/Discerning/HowToPrioritiseTasksReadyForAction/HowToPrioritiseTasksReadyForAction";
import HowToBeInnovative from "./Pages/Thought/Imagining/HowToBeInnovative/HowToBeInnovative";
import HowToDevelopStrategicLongTermGoals from "./Pages/Thought/Imagining/HowToDevelopStrategicLongTermGoals/HowToDevelopStrategicLongTermGoals";
import HowToReframeProblems from "./Pages/Thought/Imagining/HowToReframeProblems/HowToReframeProblems";
import HowToThinkAboutProblemsLaterally from "./Pages/Thought/Imagining/HowToThinkAboutProblemsLaterally/HowToThinkAboutProblemsLaterally";
import HowToBeConfidentInYourJudgementCalls from "./Pages/Thought/Shaping/HowToBeConfidentInYourJudgementCalls/HowToBeConfidentInYourJudgementCalls";
import HowToDirectPeople from "./Pages/Thought/Shaping/HowToDirectPeople/HowToDirectPeople";
import HowToImproveProcesses from "./Pages/Thought/Shaping/HowToImproveProcesses/HowToImproveProcesses";
import HowToMakeReasonedJudgements from "./Pages/Thought/Shaping/HowToMakeReasonedJudgements/HowToMakeReasonedJudgements";
import HowToFormulateActionPlans from "./Pages/Task/Driving/HowToFormulateActionPlans/HowToFormulateActionPlans";
import HowToCopeWithSetbacks from "./Pages/Task/Driving/HowToCopeWithSetbacks/HowToCopeWithSetbacks";
import HowToMaintainMomentum from "./Pages/Task/Driving/HowToMaintainMomentum/HowToMaintainMomentum";
import HowToWinAndManageResources from "./Pages/Task/Driving/HowToWinAndManageResources/HowToWinAndManageResources";
import HowToCommunicateYourVision from "./Pages/Task/Engaging/HowToCommunicateYourVision/HowToCommunicateYourVision";
import HowToDelegate from "./Pages/Task/Engaging/HowToDelegate/HowToDelegate";
import HowToEngageOthersToDeliver from "./Pages/Task/Engaging/HowToEngageOthersToDeliver/HowToEngageOthersToDeliver";
import HowToDeliverEveryTime from "./Pages/Task/Owning/HowToDeliverEveryTime/HowToDeliverEveryTime";
import HowToKnowWhenAndHowToTakeRisks from "./Pages/Task/Owning/HowToKnowWhenAndHowToTakeRisks/HowToKnowWhenAndHowToTakeRisks";
import HowToTakeControl from "./Pages/Task/Owning/HowToTakeControl/HowToTakeControl";
import HowToTakeResponsibility from "./Pages/Task/Owning/HowToTakeResponsibility/HowToTakeResponsibility";
import HowToGetTheMostOutOfYourself from "./Pages/Task/Sustaining/HowToGetTheMostOutOfYourself/HowToGetTheMostOutOfYourself";
import HowToBuildResilience from "./Pages/Task/Sustaining/HowToBuildResilience/HowToBuildResilience";
import HowToUseOptimismToAchieve from "./Pages/Task/Sustaining/HowToUseOptimismToAchieve/HowToUseOptimismToAchieve";
import Loading from "../Reusable/Loading";
import {ROLE_ADMIN, ROLE_CONSULTANT} from "../../services/constants";

export default class iLeadTools extends React.Component {

    state = {
        isLoading: false,
        isLoadingContent: false,
        project_name: this.props.location?.project_name || '',
        module: {},
        currentPage: '',
        pagesData: [],
        collapse: {
            people: true,
            thought: false,
            task: false
        }
    }

    pages = {
        Home,
        People,
        Task,
        Thought,
        HowToMotivateOthers,
        HowToRaiseEnergyLevels,
        HowToBeAssertive,
        HowToInfluenceOthers,
        HowToDevelopRapport,
        HowToCommunicateEffectively,
        HowToActivelyListen,
        HowToManageYourImpact,
        HowToManageDifficultConversations,
        HowToCreateTeamIdentity,
        HowToBuildAndMaintainTrust,
        HowToGainBuyInAndCommitment,
        HowToSupportAndChallengeInTandem,
        HowToGiveFeedback,
        HowToIdentifyYourPersonalMeaning,
        HowToBeAnEffectiveRoleModel,
        HowToIdentifyPersonalLearningStyles,
        HowToDevelopOthers,
        HowToBalanceRiskWithPotentialBenefits,
        HowToChallengeOthersEffectively,
        HowToFocusOnTheBiggerPicture,
        HowToMakeComplexIdeasSimpleClearAndConcise,
        HowToMakeEthicalDecisions,
        HowToMakeTimelyDecisions,
        HowToPrioritiseTasksReadyForAction,
        HowToBeInnovative,
        HowToDevelopStrategicLongTermGoals,
        HowToReframeProblems,
        HowToThinkAboutProblemsLaterally,
        HowToBeConfidentInYourJudgementCalls,
        HowToDirectPeople,
        HowToImproveProcesses,
        HowToMakeReasonedJudgements,
        HowToCopeWithSetbacks,
        HowToFormulateActionPlans,
        HowToMaintainMomentum,
        HowToWinAndManageResources,
        HowToCommunicateYourVision,
        HowToDelegate,
        HowToEngageOthersToDeliver,
        HowToDeliverEveryTime,
        HowToKnowWhenAndHowToTakeRisks,
        HowToTakeControl,
        HowToTakeResponsibility,
        HowToBuildResilience,
        HowToGetTheMostOutOfYourself,
        HowToUseOptimismToAchieve
    };

    urls = {
        Home: '',
        People: 'people',
        Task: 'task',
        Thought: 'thought',
        HowToMotivateOthers: 'people/mobilising/how-to-motivate-others',
        HowToRaiseEnergyLevels: 'people/mobilising/how-to-raise-energy-levels',
        HowToBeAssertive: 'people/mobilising/how-to-be-assertive',
        HowToInfluenceOthers: 'people/mobilising/how-to-influence-others',
        HowToDevelopRapport: 'people/connecting/how-to-develop-rapport',
        HowToCommunicateEffectively: 'people/connecting/how-to-communicate-effectively',
        HowToActivelyListen: 'people/connecting/how-to-actively-listen',
        HowToManageYourImpact: 'people/connecting/how-to-manage-your-impact',
        HowToManageDifficultConversations: 'people/connecting/how-to-manage-difficult-conversations',
        HowToCreateTeamIdentity: 'people/building/how-to-create-team-identity',
        HowToBuildAndMaintainTrust: 'people/building/how-to-build-and-maintain-trust',
        HowToGainBuyInAndCommitment: 'people/building/how-to-gain-buy-in-and-commitment',
        HowToSupportAndChallengeInTandem: 'people/building/how-to-support-andc-hallenge-in-tandem',
        HowToGiveFeedback: 'people/building/how-to-give-feedback',
        HowToIdentifyYourPersonalMeaning: 'people/meaning/how-to-identify-your-personal-meaning',
        HowToBeAnEffectiveRoleModel: 'people/meaning/how-to-be-an-effective-role-model',
        HowToIdentifyPersonalLearningStyles: 'people/meaning/how-to-identify-personal-learning-styles',
        HowToDevelopOthers: 'people/meaning/how-to-develop-others',
        HowToDevelopStrategicLongTermGoals: 'thought/imagining/how-to-develop-strategic-long-term-goals',
        HowToBeInnovative: 'thought/imagining/how-to-be-innovative',
        HowToThinkAboutProblemsLaterally: 'thought/imagining/how-to-think-about-problems-laterally',
        HowToReframeProblems: 'thought/imagining/how-to-reframe-problems',
        HowToPrioritiseTasksReadyForAction: 'thought/discerning/how-to-prioritise-tasks-ready-for-action',
        HowToMakeTimelyDecisions: 'thought/discerning/how-to-make-timely-decisions',
        HowToFocusOnTheBiggerPicture: 'thought/discerning/how-to-focus-on-the-bigger-picture',
        HowToMakeComplexIdeasSimpleClearAndConcise: 'thought/discerning/how-to-make-complex-ideas-simple-clear-and-concise',
        HowToMakeEthicalDecisions: 'thought/discerning/how-to-make-ethical-decisions',
        HowToMakeReasonedJudgements: 'thought/shaping/how-to-make-reasoned-judgements',
        HowToDirectPeople: 'thought/shaping/how-to-direct-people',
        HowToImproveProcesses: 'thought/shaping/how-to-improve-processes',
        HowToBeConfidentInYourJudgementCalls: 'thought/shaping/how-to-be-confident-in-your-judgement-calls',
        HowToChallengeOthersEffectively: 'thought/challenging/how-to-challenge-others-effectively',
        HowToBalanceRiskWithPotentialBenefits: 'thought/challenging/how-t-obalance-risk-with-potential-benefits',
        HowToTakeResponsibility: 'task/owning/how-to-take-responsibility',
        HowToDeliverEveryTime: 'task/owning/how-to-deliverevery-time',
        HowToTakeControl: 'task/owning/how-to-take-control',
        HowToKnowWhenAndHowToTakeRisks: 'task/owning/how-to-know-when-and-how-to-take-risks',
        HowToMaintainMomentum: 'task/driving/how-to-maintain-momentum',
        HowToCopeWithSetbacks: 'task/driving/how-to-cope-with-setbacks',
        HowToFormulateActionPlans: 'task/driving/how-to-formulate-action-plans',
        HowToWinAndManageResources: 'task/driving/how-to-win-and-manage-resources',
        HowToCommunicateYourVision: 'task/engaging/how-to-communicate-your-vision',
        HowToDelegate: 'task/engaging/how-to-delegate',
        HowToEngageOthersToDeliver: 'task/engaging/how-to-engage-others-to-deliver',
        HowToBuildResilience: 'task/sustaining/how-to-build-resilience',
        HowToUseOptimismToAchieve: 'task/sustaining/how-to-use-optimism-to-achieve',
        HowToGetTheMostOutOfYourself: 'task/sustaining/how-to-get-the-most-out-of-yourself'
    };

    project_id = this.props.match.params.id;

    async componentDidMount() {

        let currentPage = '';

        if (this.props.match.params.group) {
            currentPage = this.props.match.params.group;

            this.setState({
                collapse: {
                    people: currentPage === 'people',
                    thought: currentPage === 'thought',
                    task: currentPage === 'task'
                }
            });
        }
        if (this.props.match.params.subgroup)
            currentPage = currentPage + '/' + this.props.match.params.subgroup;

        if (this.props.match.params.title)
            currentPage = currentPage + '/' + this.props.match.params.title;

        if (currentPage) {
            this.setState({
                currentPage: Object.keys(this.urls).find(key => this.urls[key] === currentPage)
            });
        } else {
            this.setState({
                currentPage: 'Home'
            });
        }
        if (this._isAuth(this.props.user) && !this.props.user?.hasRole(ROLE_ADMIN) && !this.props.user?.hasRole(ROLE_CONSULTANT)) {
            await this._getProject();
            await this._getIleadToolsPages();
        }
    }

    async componentDidUpdate(prevProps, prevState) {

        if (prevProps.user !== this.props.user && this.props.user) {
            if (this._isAuth(this.props.user) && !this.props.user?.hasRole(ROLE_ADMIN) && !this.props.user?.hasRole(ROLE_CONSULTANT)) {
                await this._getProject();
                await this._getIleadToolsPages();
            }
        }

        if(prevState.currentPage !== this.state.currentPage)
            if (this.props.match.params.group) {
                let groupPage = this.props.match.params.group;

                if (groupPage === 'people' || groupPage === 'thought' || groupPage === 'task')
                    this.setState({
                        collapse: {
                            people: groupPage === 'people',
                            thought: groupPage === 'thought',
                            task: groupPage === 'task'
                        }
                    });
            }
    }

    _isAuth = user =>  user && Object.keys(user).length;

    _getProject = async () => {

        this.setState({
            isLoading: true
        });

        let project = await http.route(`employee/project/${this.project_id}`).get();

        if (!project.isError) {
            this.setState({
                project_name: project.data.name,
                module: project.data.project_details[0]?.module,
                isLoading: false
            });
        } else if (project.isError) {
            this.setState({
                isLoading: false
            });
        }
    };

    _getIleadToolsPages = async () => {

        this.setState({
            isLoading: true
        });

        let res = await http.route(`employee/project/${this.project_id}/ilead/ilead-tools-pages`).get();

        if (!res.isError) {
            this.setState({
                pagesData: res.data,
                isLoading: false
            });
        } else if (res.isError) {
            this.setState({
                isLoading: false
            });
        }
    };

    savePageStatus =  () => async (page) => {

        this.setState({
            isLoadingContent: true
        });

        let res = await http.route(`employee/project/${this.project_id}/ilead/ilead-tools-pages-status`).post({
            page
        });

        if (!res.isError) {
            this.setState({
                isLoadingContent: false,
                pagesData: {
                    ...this.state.pagesData,
                    [page]: res.data
                }
            });
        } else if (res.isError) {
            this.setState({
                isLoadingContent: false
            });
        }
    };

    savePageData =  () => async (page, pageData) => {

        this.setState({
            isLoadingContent: true
        });

        let res = await http.route(`employee/project/${this.project_id}/ilead/ilead-tools-pages-data`).post({
            pageData,
            page
        });

        if (!res.isError) {
            this.setState({
                isLoadingContent: false,
                pagesData: {
                    ...this.state.pagesData,
                    [page]: {
                        ...this.state.pagesData?.[page],
                        data: {
                            ...this.state.pagesData?.[page]?.data,
                            ...pageData
                        }
                    }

                }
            });
        } else if (res.isError) {
            this.setState({
                isLoadingContent: false
            });
        }
    };

    handleChangeCollapse = (type) => _ => {
        this.setState({
            collapse: {
                ...this.state.collapse,
                [type]: !this.state.collapse[type]
            }
        });
    }

    handleChangePage = (currentPage) => _ => {
        this.setState({
            currentPage
        });

        let urlPrefix = '/admin/ilead-tools/';

        if (!!this.props.match.params.id)
            urlPrefix = `/project/${this.props.match.params.id}/ilead/ilead-tools/`;

        if(this.props.user?.hasRole(ROLE_ADMIN)){
            window.top.postMessage({payload: {iltUrlSuffix: this.urls[currentPage]}}, '*');
            this.props.history.push(urlPrefix + this.urls[currentPage]);
        }else{
            window.top.postMessage({payload: {iltUrlSuffix: this.urls[currentPage]}}, '*');
            this.props.history.push(urlPrefix + this.urls[currentPage]);
        }

    };

    render() {
        const {isLoading, currentPage} = this.state;
        const Page = this.pages[currentPage] || 'Home';

        return (
            <div className={'ilead-tools-container'}>
                <Row className={'pt-4 project-logo-row ilead-tools-header d-flex justify-content-between align-items-center'}>
                    <div className={'project-title font-size-20 cursor-pointer'}
                         onClick={this.handleChangePage('Home')}>
                        <img className={'logo'} src={ilead_tools} />
                    </div>
                    {(!isLoading && this._isAuth(this.props.user) && !this.props.user?.hasRole(ROLE_ADMIN) && this.state.module.slug !== 'ilead_tools' ) && <div className={'ilead-menu'}>
                        <div onClick={() => {
                            window.top.location.href = `${window.location?.ancestorOrigins?.[0]}/project/${this.project_id}/ilead`;
                        }} className={'cursor-pointer'}>iLEAD Menu</div>
                    </div>}
                    <div className={'font-weight-regular font-size-20'}>{this.state.project_name}</div>
                </Row>
                <Row className={'ilead-tools-body'}>
                    <Col className={'pl-0 mb-30 ilead-tools-sidebar'} xl={3} lg={4} md={5} sm={12}>
                        <SideBar collapse={this.state.collapse}
                                 handleChangeCollapse={this.handleChangeCollapse}
                                 handleChangePage={this.handleChangePage}
                                 currentPage={currentPage}
                        />
                    </Col>
                    <Col className={'ilead-tools-pages'}  xl={9} lg={8} md={7}  sm={12}>
                        <div className={'border-line pink'}/>

                        <div className={'ilead-tools-pages-content h-100'}>
                            {isLoading ?
                                <div className="p-2">
                                    <Loading className="bg-transparent" loading={isLoading}/>
                                </div>
                                :
                                <Page handleChangePage={this.handleChangePage}
                                      savePageStatus={this._isAuth(this.props.user) && !this.props.user?.hasRole(ROLE_ADMIN) ? this.savePageStatus : () => () => {}}
                                      savePageData={this._isAuth(this.props.user) && !this.props.user?.hasRole(ROLE_ADMIN) ? this.savePageData : () => () => {}}
                                      pagesData={this.state.pagesData}/>
                            }
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
